import React, { useEffect, useRef } from 'react'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import AdmitChances from 'pages/StudentProfile/components/TabsProfile/Components/WishlistCourseCard/components/AdmitChances'
import { parseDateForDeadLine } from 'shared/utils/parseDateForDeadLine'
import { getOrdinalSuffix } from 'shared/utils/getOrdinalSuffix'
import {
	canOpenUniversityDetails,
	getUniversityCardModel,
	getUniversityDetailsBlockReason,
	requestUniversityDetails,
} from '../universityCardModel'
import s from './UniversityCardMobile.module.scss'

export default function UniversityCardMobile({
	item,
	selected = false,
	onToggle,
	onViewDetails,
}) {
	const model = getUniversityCardModel(item)
	const canOpenDetails = canOpenUniversityDetails(model)
	const warnedRef = useRef(false)
	const deadlineWarn =
		parseDateForDeadLine(model.appDeadline) === 'isTwo' ||
		parseDateForDeadLine(model.appDeadline) === 'isClose'

	useEffect(() => {
		if (canOpenDetails || warnedRef.current) return
		const reason = getUniversityDetailsBlockReason(model)
		if (!reason) return
		warnedRef.current = true
		console.warn(reason)
	}, [canOpenDetails, model])

	return (
		<article className={`${s.card} ${selected ? s.selected : ''}`}>
			<div className={s.header}>
				<div className={s.titleWrap}>
					<h3 className={s.title}>{model.programName}</h3>
					{model.relatedCoursesLabel ? (
						<span className={s.related}>{model.relatedCoursesLabel}</span>
					) : null}
				</div>
				<div className={s.meta}>
					<AdmitChances type={model.type} />
					<div className={`${s.deadline} ${deadlineWarn ? s.deadlineWarn : ''}`}>
						<span className={s.deadlineLabel}>Deadline</span>
						<span className={s.deadlineValue}>{model.appDeadline}</span>
					</div>
				</div>
			</div>

			<div className={s.university}>
				{model.logo ? (
					<img className={s.logo} src={model.logo} alt="" />
				) : (
					<div className={s.logo} />
				)}
				<div>
					<p className={s.uniName}>{model.uniTitle}</p>
					<p className={s.uniLocation}>
						{model.location || model.country || '—'}
					</p>
				</div>
			</div>

			<div className={s.stats}>
				<div className={s.stat}>
					<p className={s.statLabel}>{model.rankTitle}</p>
					<p className={s.statValue}>
						{model.rank ?? '—'}
						{model.rank
							? model.isImpliedRank
								? '+'
								: (
										<sup>{getOrdinalSuffix(model.rank)}</sup>
									)
							: null}
					</p>
				</div>
				<div className={s.stat}>
					<p className={s.statLabel}>{model.eligibilityShortTitle}</p>
					<p className={`${s.statValue} ${s.statValueClamp}`} title={model.eligibilityHint}>
						{model.eligibility}
					</p>
				</div>
				<div className={s.stat}>
					<p className={s.statLabel}>Annual Fee</p>
					<p className={s.statValue}>{model.fee}</p>
				</div>
			</div>

			<div className={s.footer}>
				<button
					type="button"
					className={`${s.selectBtn} ${selected ? s.selectBtnActive : ''}`}
					onClick={e => {
						e.stopPropagation()
						onToggle?.()
					}}
				>
					{selected ? (
						<>
							<CheckIcon className={s.selectBtnIcon} />
							Selected
						</>
					) : (
						'Select'
					)}
				</button>
				<button
					type="button"
					className={s.btn}
					onClick={e => {
						e.stopPropagation()
						requestUniversityDetails(model, onViewDetails)
					}}
					disabled={!canOpenDetails}
					title={
						canOpenDetails
							? undefined
							: getUniversityDetailsBlockReason(model) || undefined
					}
				>
					View Details
				</button>
			</div>
		</article>
	)
}
